var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 231 149",
    id: "vector",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group_4",
    transform: "translate(1 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(56.364 35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M105.326.0H19.612C15.204.0 11.54 3.394 11.202 7.788L5.714 79.221C5.714 90.124 14.553 98.962 25.455 98.962H99.483C110.385 98.962 119.224 90.124 119.224 79.221L113.736 7.788C113.398 3.394 109.734.0 105.326.0",
    fill: "#f6f8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    d: "M4.805 22.053 5.616 11.505H25.244L19.377 22.053H4.805z",
    fill: "#fff",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    d: "M47.991 11.505H24.915L19.049 22.053H42.124z",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_3",
    d: "M70.738 11.505H47.662L41.795 22.053H64.871z",
    fill: "#fff",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_4",
    d: "M94.009 11.505H70.933L65.067 22.053H88.142z",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_5",
    d: "M108.671 11.505 109.481 22.053H88.338l5.866-10.548H108.671z",
    fill: "#fff",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_6",
    d: "M1e2.322H14.286C9.878.322 6.214 3.716 5.876 8.111L.388 79.544C.388 90.446 9.227 99.284 20.129 99.284H94.157C105.059 99.284 113.898 90.446 113.898 79.544L108.41 8.111C108.072 3.716 104.408.322 1e2.322zM.637 79.545H113.649",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_7",
    d: "M95.15 56.587V45.007H98.11V56.587H95.15zM49.536 41.533V53.718H55.987V56.587H46.577V41.533H49.536zM62.218 54.115C60.399 54.102 59.112 52.739 59.132 50.848 59.152 48.966 60.429 47.661 62.25 47.663 64.088 47.665 65.354 48.989 65.345 50.9 65.336 52.803 64.048 54.128 62.218 54.115M62.248 45.016C58.85 45.004 56.248 47.547 56.249 50.88 56.25 54.219 58.838 56.759 62.237 56.756 65.658 56.754 68.23 54.236 68.23 50.891 68.229 47.532 65.68 45.028 62.248 45.016M78.062 50.934C78.038 52.818 76.757 54.128 74.938 54.115 73.119 54.102 71.832 52.739 71.852 50.848 71.872 48.966 73.149 47.661 74.971 47.663 76.795 47.665 78.054 48.972 78.062 50.861V50.934zM78.06 45.814C77.17 45.31 76.121 45.02 74.969 45.016 71.571 45.003 68.969 47.547 68.969 50.88 68.97 54.219 71.558 56.759 74.958 56.756 76.114 56.755 77.169 56.462 78.065 55.951 78.066 56.729 78.066 57.219 78.066 57.219 78.057 59.123 76.768 60.444 74.938 60.444 72.588 60.444 71.554 58.166 71.554 58.166L69.402 59.473C69.402 59.473 70.639 63.085 74.958 63.085 78.378 63.083 80.951 60.565 80.95 57.22V45.007H78.06C78.06 45.007 78.06 45.308 78.06 45.814zM90.78 45.814C90.78 45.308 90.78 45.007 90.78 45.007H93.671V57.22C93.671 60.565 91.099 63.083 87.679 63.085 83.359 63.085 82.122 59.473 82.122 59.473L84.275 58.166C84.275 58.166 85.308 60.444 87.658 60.444 89.489 60.444 90.778 59.123 90.786 57.219 90.786 57.219 90.786 56.729 90.786 55.951 89.89 56.462 88.835 56.756 87.679 56.756 84.279 56.759 81.69 54.219 81.69 50.88 81.689 47.547 84.291 45.004 87.689 45.016 88.842 45.02 89.89 45.31 90.78 45.814zM96.63 44.492C95.813 44.492 95.15 43.829 95.15 43.012 95.15 42.195 95.813 41.532 96.63 41.532 97.447 41.532 98.11 42.195 98.11 43.012 98.11 43.829 97.447 44.492 96.63 44.492zM40.564 43.162C41.676 43.838 43.025 46.121 43.025 46.121 43.025 46.121 43.869 47.246 43.855 47.391 43.815 47.803 43.613 48.169 43.459 48.446 43.305 48.723 42.689 49.845 42.188 50.162 41.685 50.48 39.712 51.365 38.134 51.823 37.702 51.963 36.853 52.306 36.365 52.849 35.787 53.492 29.87 59.452 29.87 59.452L28.954 59.186C28.954 59.186 30.489 57.39 30.025 55.125 29.655 53.312 28.667 52.276 28.667 52.276 28.667 52.276 30.249 54.656 28.992 57.328 28.71 57.927 28.159 58.663 27.516 59.209 27.138 59.507 26.968 59.511 27.211 59.584 27.663 59.72 28.081 59.841 30.206 60.481 31.649 60.901 31.995 62.025 31.948 62.481 31.929 62.659 31.836 63.085 31.836 63.085L25.677 61.189C25.677 61.189 21.519 59.89 21.304 59.871 20.943 59.838 20.322 59.395 20.312 58.902 20.303 58.463 20.347 57.81 20.211 57.563 19.998 57.273 18.536 55.909 17.424 54.329 16.42 52.9 15.999 51.357 16.244 49.704 16.676 46.796 20.197 44.447 22.969 44.924 24.555 45.196 26.796 45.837 33.818 47.076 33.705 45.898 34.098 44.839 34.698 43.928 34.463 43.622 33.463 42.834 31.542 43.195 29.845 43.516 28.466 43.466 27.626 43.416 26.147 43.327 21.069 41.511 20.526 41.358 19.767 41.144 20.273 40.732 20.815 40.503 21.054 40.401 21.447 40.238 22.085 40.043 23.638 40.77 25.484 41.539 27.206 42.051 28.085 42.313 29.595 42.439 31.473 42.322 33.424 42.202 34.888 42.641 35.272 43.186 35.061 42.852 34.016 41.936 31.869 41.982 29.988 42.021 28.516 41.721 27.622 41.516 26.688 41.303 24.54 40.127 22.831 39.152 21.662 38.484 20.699 37.91 20.473 37.804 19.798 37.486 20.21 37.313 20.826 37.165 21.345 37.04 22.832 36.593 25.241 36.525 28.292 36.439 31.296 38.022 33.024 38.749 34.752 39.476 38.671 42.279 38.671 42.279 38.671 42.279 38.734 42.327 38.835 42.399 39.125 42.51 39.902 42.814 40.564 43.162zM90.783 50.935V50.861C90.774 48.971 89.516 47.665 87.692 47.663 85.87 47.661 84.593 48.966 84.573 50.848 84.553 52.739 85.84 54.102 87.658 54.115 89.477 54.128 90.758 52.819 90.783 50.935z",
    fill: "#e9ebed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group_1",
    transform: "translate(6.13 77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_8",
    d: "M25.446 56.955C18.037 56.955 11.439 52.487 8.999 45.818L6.275 27.621C4.974 23.783 8.999.0 36.273.0 53.733.0 66.07 6.821 73.086 22.246 76.453 29.648 77.849 42.787 78.403 50.602 78.646 54.04 75.787 56.955 72.173 56.955H71.433 25.446z",
    fill: "#f6f8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_9",
    d: "M19.385 56.955C11.976 56.955 5.378 52.487 2.938 45.818L.214 27.621C-1.087 23.783 2.938.0 30.212.0 47.672.0 60.009 6.821 67.025 22.246 70.392 29.648 71.788 42.787 72.342 50.602 72.585 54.04 69.725 56.955 66.111 56.955H65.372 19.385z",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_10",
    d: "M64.693 17.761C65.527 19.166 66.304 20.66 67.025 22.246 69.742 28.219 71.176 37.928 71.919 45.56 51.566 44.288 39.394 42.629 35.406 40.582 21.71 33.555 29.714 23.749 29.945 23.719L64.693 17.761z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_11",
    d: "M64.693 17.761C65.527 19.166 66.304 20.66 67.025 22.246 69.742 28.219 71.176 37.928 71.919 45.56 51.566 44.288 39.394 42.629 35.406 40.582 21.71 33.555 29.714 23.749 29.945 23.719L64.693 17.761z",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_12",
    d: "M35.152 28.815C35.152 29.699 34.435 30.415 33.551 30.415 32.668 30.415 31.952 29.699 31.952 28.815 31.952 27.931 32.668 27.215 33.551 27.215 34.435 27.215 35.152 27.931 35.152 28.815z",
    fill: "#e9ebed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_13",
    d: "M9.147 29.847 1.141 33.651.214 27.456 8.125 26.772C8.973 26.658 9.767 27.211 9.954 28.046 10.114 28.759 9.785 29.492 9.147 29.847zM8.205 52.285H71.241",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group_2",
    transform: "translate(158.818 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_14",
    d: "M53.763 69.79 2.775 69.878C1.758 69.88.932 69.057.93 68.039L.816 2.145C.814 1.128 1.637.302 2.655.3L53.642.212C54.659.21 55.485 1.033 55.487 2.05L55.601 67.944C55.603 68.962 54.78 69.788 53.763 69.79",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_15",
    d: "M59.217 69.79 8.23 69.878C7.213 69.88 6.386 69.057 6.385 68.039L6.27 2.145C6.269 1.128 7.092.302 8.109.3L59.096.212C60.114.21 60.94 1.033 60.942 2.05L61.056 67.944C61.058 68.962 60.234 69.788 59.217 69.79",
    fill: "#f6f8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_16",
    d: "M7.843 53.277 22.58 53.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_17",
    d: "M7.843 53.277 22.58 53.25",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_18",
    d: "M7.851 57.882 22.587 57.854",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_19",
    d: "M7.851 57.882 22.587 57.854",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_20",
    d: "M1.853 7.568C1.853 7.568 21.756 14.852 28.62 14.84 35.485 14.829 55.889 7.452 55.889 7.452L56.062 7.313 56.053 2.174C56.051 1.088 55.458.233 54.364.235L3.212.323C2.118.325 1.27 1.183 1.272 2.268L1.281 7.501 1.853 7.568z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_21",
    d: "M1.853 7.568C1.853 7.568 21.756 14.852 28.62 14.84 35.485 14.829 55.889 7.452 55.889 7.452L56.062 7.313 56.053 2.174C56.051 1.088 55.458.233 54.364.235L3.212.323C2.118.325 1.27 1.183 1.272 2.268L1.281 7.501 1.853 7.568z",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_22",
    d: "M54.217 69.79 3.23 69.878C2.213 69.88 1.386 69.057 1.385 68.039L1.27 2.145C1.269 1.128 2.092.302 3.109.3L54.096.212C55.114.21 55.94 1.033 55.942 2.05L56.056 67.944C56.058 68.962 55.234 69.788 54.217 69.79z",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_23",
    d: "M0 134H229.091M185 49H214.072M192 43H221.072M172 43h2m8 0h2M16 21H45.072M5.091 64.636H7.273M11.636 64.636H13.818M51 21h2M136 1H165.072M114 20h2m5 0h6M23 15H52.072",
    fill: "none",
    stroke: "#e9ebed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "group_3",
    transform: "translate(80 72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_24",
    d: "M6 0H32.035C35.359.0 38.035 2.676 38.035 6V68.952C38.035 72.276 35.359 74.952 32.035 74.952H6C2.676 74.952.0 72.276.0 68.952V6C0 2.676 2.676.0 6 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_25",
    d: "M7.492 1.492H33.527c3.323999999999998.0 6 2.676 6 6V70.444C39.527 73.768 36.851 76.444 33.527 76.444H7.492c-3.324.0-6-2.676000000000002-6-6V7.492c0-3.324 2.676-6 6-6z",
    fill: "#ccf1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_26",
    d: "M5.94-.061H32.095c3.323999999999998.0 6 2.676 6 6V69.013C38.095 72.337 35.419 75.013 32.095 75.013H5.94C2.616 75.013-.06 72.337-.06 69.013V5.939c0-3.324 2.676-6 6-6z",
    fill: "none",
    stroke: "#757d8d",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_27",
    d: "M5.041 7.601H33.11C34.218 7.601 35.11 8.493 35.11 9.601V66.01C35.11 67.118 34.218 68.01 33.11 68.01H5.041C3.933 68.01 3.041 67.118 3.041 66.01V9.601C3.041 8.493 3.933 7.601 5.041 7.601z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_28",
    d: "M3.041 57.295V55.135H25.014V47.036H9.087v4.189C9.087 51.512 8.973 51.788 8.769 51.99 8.565 52.193 8.289 52.306 8.002 52.305 7.405 52.305 6.922 51.821 6.922 51.225V47.036H3.041V44.876H6.922V21.171C6.605 21.159 6.294 21.141 5.988 21.119H3.041V18.511C3.961 18.722 4.958 18.875 6.038 18.959H25.014V7.601h2.16V18.959H35.11v2.16H27.174V44.876H35.11V47.036H27.174V55.135H35.11V57.295H27.174V68.011h-2.16V57.295H3.041zM7.196 68.011V61.615C7.196 61.018 7.679 60.535 8.276 60.535 8.872 60.535 9.356 61.018 9.356 61.615V68.011H7.196zM25.014 44.876V21.119H9.087V44.876H25.014z",
    fill: "#f6f8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_29",
    d: "M8 11H30C31.108 11 32 11.892 32 13v8C32 22.108 31.108 23 30 23H8C6.892 23 6 22.108 6 21V13C6 11.892 6.892 11 8 11z",
    fill: "#deecf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_30",
    d: "M10.5 15h17C27.777 15 28 15.223 28 15.5 28 15.777 27.777 16 27.5 16h-17C10.223 16 10 15.777 10 15.5 10 15.223 10.223 15 10.5 15z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_31",
    d: "M10.5 18h11C21.777 18 22 18.223 22 18.5 22 18.777 21.777 19 21.5 19h-11C10.223 19 10 18.777 10 18.5 10 18.223 10.223 18 10.5 18z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_32",
    d: "M8 61H30C31.108 61 32 61.892 32 63v1C32 65.108 31.108 66 30 66H8C6.892 66 6 65.108 6 64V63C6 61.892 6.892 61 8 61z",
    fill: "#deecf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_33",
    d: "M10.5 63h17C27.777 63 28 63.223 28 63.5 28 63.777 27.777 64 27.5 64h-17C10.223 64 10 63.777 10 63.5 10 63.223 10.223 63 10.5 63z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_34",
    d: "M11.556 39.117C11.556 39.251 11.595 39.895 11.605 39.972 11.852 42.351 13.084 44.841 15.019 47.336 16.233 48.896 17.595 50.335 19.085 51.633 19.376 51.879 19.801 51.879 20.092 51.633 21.584 50.336 22.947 48.896 24.161 47.336 26.096 44.841 27.328 42.351 27.574 39.97 27.574 39.884 27.624 39.251 27.624 39.117 27.624 34.796 24.026 31.297 19.583 31.297 15.141 31.297 11.556 34.796 11.556 39.117z",
    fill: "#ccf1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_35",
    d: "M18.792 30.044C23.116 30.296 26.567 33.803 26.58 38.087 26.58 38.153 26.574 38.274 26.557 38.525 26.557 38.536 26.557 38.536 26.556 38.548 26.538 38.823 26.534 38.898 26.531 38.966 26.279 41.287 25.113 43.788 23.056 46.455 21.833 48.027 20.46 49.476 18.95 50.79 18.572 51.107 18.02 51.107 17.634 50.784 16.131 49.476 14.759 48.027 13.536 46.456 11.48 43.83 10.303 41.299 10.062 38.98 10.048 38.877 10.011 38.226 10.011 38.087 10.011 33.64 13.731 30.027 18.292 30.027h.5V30.044z",
    fill: "none",
    stroke: "#757d8d",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_36",
    d: "M24.078 39.114C24.078 39.94 23.861 40.751 23.448 41.466 23.035 42.182 22.441 42.776 21.725 43.189 21.01 43.602 20.199 43.819 19.373 43.819 18.547 43.819 17.736 43.602 17.02 43.189 16.305 42.776 15.711 42.182 15.298 41.466 14.885 40.751 14.668 39.94 14.668 39.114 14.668 38.288 14.885 37.477 15.298 36.761 15.711 36.046 16.305 35.452 17.02 35.039 17.736 34.626 18.547 34.409 19.373 34.409 20.199 34.409 21.01 34.626 21.725 35.039 22.441 35.452 23.035 36.046 23.448 36.761 23.861 37.477 24.078 38.288 24.078 39.114z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_37",
    d: "M18.336 33.131H18.337C21.066 33.136 23.277 35.347 23.281 38.077 23.281 40.808 21.067 43.022 18.336 43.022 15.605 43.022 13.39 40.808 13.39 38.077 13.39 35.345 15.605 33.131 18.336 33.131z",
    fill: "none",
    stroke: "#757d8d",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_38",
    d: "M15.984 3.443H22.507C22.791 3.443 23.019 3.671 23.019 3.955 23.019 4.239 22.791 4.467 22.507 4.467H15.984C15.7 4.467 15.472 4.239 15.472 3.955 15.472 3.671 15.7 3.443 15.984 3.443z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_39",
    d: "M16.496 70.5H21.995C22.562 70.5 23.019 70.957 23.019 71.524 23.019 72.091 22.562 72.548 21.995 72.548H16.496C15.929 72.548 15.472 72.091 15.472 71.524 15.472 70.957 15.929 70.5 16.496 70.5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_40",
    d: "M151 129C151 133.772 149.102 138.354 145.728 141.728 142.354 145.102 137.772 147 133 147 128.228 147 123.646 145.102 120.272 141.728 116.898 138.354 115 133.772 115 129 115 124.228 116.898 119.646 120.272 116.272 123.646 112.898 128.228 111 133 111 137.772 111 142.354 112.898 145.728 116.272 149.102 119.646 151 124.228 151 129z",
    fill: "#fff",
    stroke: "#757d8d",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_41",
    d: "M128.983 125.364H130.727C131.48 125.364 132.091 125.974 132.091 126.727 132.091 127.48 131.48 128.091 130.727 128.091H125.955C125.201 128.091 124.591 127.48 124.591 126.727V121.955C124.591 121.201 125.201 120.591 125.955 120.591 126.708 120.591 127.318 121.201 127.318 121.955V123.149C128.912 121.54 131.102 120.591 133.455 120.591 136.796 120.591 139.793 122.506 141.227 125.459 141.556 126.136 141.274 126.952 140.596 127.281 139.919 127.61 139.103 127.327 138.774 126.65 137.792 124.628 135.742 123.318 133.455 123.318 131.705 123.318 130.089 124.083 128.983 125.364zM136.973 132.636H135.228C134.475 132.636 133.864 132.026 133.864 131.273 133.864 130.52 134.475 129.909 135.228 129.909H140.001C140.754 129.909 141.364 130.52 141.364 131.273V136.045C141.364 136.799 140.754 137.409 140.001 137.409 139.248 137.409 138.637 136.799 138.637 136.045V134.851C137.044 136.46 134.853 137.409 132.501 137.409 129.159 137.409 126.162 135.494 124.728 132.541 124.399 131.864 124.682 131.048 125.359 130.719 126.037 130.39 126.853 130.673 127.181 131.35 128.163 133.372 130.214 134.682 132.501 134.682 134.25 134.682 135.867 133.917 136.973 132.636z",
    fill: "#00baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_42",
    d: "M70 147h90",
    fill: "none",
    stroke: "#757d8d",
    strokeWidth: 1,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateApp);
export default __webpack_public_path__ + "static/media/update_app.98c77ce6.svg";
export { ForwardRef as ReactComponent };